"use client";
import type { IconType } from "react-icons";
import {
  FaBolt,
  FaDownload,
  FaMobile,
  FaMoneyBillWave,
  FaRocket,
  FaUserTie,
} from "react-icons/fa";

interface FeatureCardProps {
  icon: string;
  title: string;
  description: string;
  color: string;
  index: number;
}

const iconMap: Record<string, IconType> = {
  FaBolt,
  FaMoneyBillWave,
  FaUserTie,
  FaDownload,
  FaMobile,
  FaRocket,
};

const accentStyles = [
  "from-teal-500 to-emerald-500",
  "from-indigo-500 to-violet-500",
  "from-sky-500 to-cyan-500",
  "from-amber-500 to-orange-500",
  "from-rose-500 to-pink-500",
  "from-fuchsia-500 to-purple-500",
];

export default function FeatureCard({ icon, title, description, index }: FeatureCardProps) {
  const IconComponent = iconMap[icon];
  const accent = accentStyles[index % accentStyles.length];

  return (
    <article className="group relative overflow-hidden rounded-3xl border border-slate-200/80 bg-white p-8 shadow-[0_18px_40px_-24px_rgba(15,23,42,0.35)] transition-all duration-300 hover:-translate-y-1.5 hover:shadow-[0_28px_50px_-20px_rgba(79,70,229,0.28)] dark:border-slate-800 dark:bg-slate-900">
              <div className={`mb-6 flex h-14 w-14 items-center justify-center rounded-2xl bg-gradient-to-br ${accent} text-white shadow-lg transition duration-300 group-hover:scale-110 group-hover:-rotate-6`}>
        {IconComponent && <IconComponent className="text-2xl" />}
      </div>
      <h3 className="mb-3 text-xl font-semibold tracking-tight text-slate-900 dark:text-white">
        {title}
      </h3>
      <p className="leading-relaxed text-slate-600 dark:text-slate-300">
        {description}
      </p>
      <div className={`pointer-events-none absolute -right-8 -top-8 h-28 w-28 rounded-full bg-gradient-to-br ${accent} opacity-10 transition-transform duration-300 group-hover:scale-125`} />
    </article>
  );
}
